import { createApp } from 'vue'

import pinia from '@/stores/index'
import { registerIcons, registerSvgIconIcons } from '@/utils/common'
import { init } from '@/preset'

import App from './App.vue'
import router from './router'

import '@/assets/js/iconfont'
import '@/api/preset'
import 'element-plus/dist/index.css'
import './styles/index.scss'
import { useAppStore } from '@/stores/app'

async function start () {
  const app = createApp(App)
  app.use(pinia)

  const render = async () => {
    app.use(router)
    // 全局注册
    registerIcons(app) // icons
    registerSvgIconIcons(app) // svg icons

    // 初始化应用依赖
    await init(router)
    app.mount('#app')
  }
  if (window.__POWERED_BY_WUJIE__) {
    window.__WUJIE_MOUNT = () => {
      render()
    }
    window.__WUJIE_UNMOUNT = () => {
      app.unmount()
    }
  } else {
    render()
  }
  function isMobile () {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
  }
  const appStore = useAppStore()

  if (isMobile()) {
    // 是移动端
    appStore.setIsMobile(true)
  } else {
    // 不是移动端
    appStore.setIsMobile(false)
  }
}

start()
